<rid-memory-match
  [pairs]="[
    {
      card1: { content: { type: 'TEXT', text: 'Tijger' } },
      card2: {
        content: {
          type: 'AUDIO',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
      },
    },
    {
      card1: { content: { type: 'TEXT', text: 'Leeuw' } },
      card2: {
        content: {
          type: 'IMAGE',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/BJuCpMZwjLRDH22qN_3C-.png',
        },
      },
    },
    {
      card1: { content: { type: 'TEXT', text: 'Kat' } },
      card2: { content: { type: 'TEXT', text: 'Kat' } },
    },
    {
      card1: { content: { type: 'TEXT', text: 'Varken' } },
      card2: { content: { type: 'TEXT', text: 'Varken' } },
    },
    {
      card1: { content: { type: 'TEXT', text: 'Koe' } },
      card2: { content: { type: 'TEXT', text: 'Koe' } },
    },
    {
      card1: { content: { type: 'TEXT', text: 'Monumentaal' } },
      card2: { content: { type: 'TEXT', text: 'Monumentaal' } },
    },
  ]"
  (finished)="$router.navigate(['/mechanics/games'])"
/>
